import React, { useEffect } from "react";
import { Stack, Box } from "@mui/material";

import { HubButton, HubHookFormWrapper, HubToolbar } from "../../components";
import {
  useGetQuickWorkOrderData,
  usePutAdminQuickUpdateWorkOrder,
} from "../../hooks";

import { StyledDrawer } from "./styles";
import QuickWorkOrderDetailsContent from "./QuickWorkOrderDetailsContent";
import { getObjectDifferences, payloadMapper } from "./helper";
import QuickWorkOrderSubmitButton from "./QuickWorkOrderSubmitButton";

export const QuickWorkOrderDetailsDialog = ({ id, setOpen = () => {} }) => {
  const { data, isLoading } = useGetQuickWorkOrderData(id);
  const { mutate, isSuccess } = usePutAdminQuickUpdateWorkOrder();

  const onClose = () => setOpen(null);

  useEffect(() => {
    isSuccess && onClose();
  }, [isSuccess]);

  const defaultValues = {
    routeId: data?.currentRoute,
    startDate: data?.startDate,
    dueDate: data?.dueDate,
    priority: data?.priority,
    quantity: data?.quantity,
    trees: data?.trees,
  };

  const onSubmit = (formData) => {
    const formValues = payloadMapper(formData);
    const changedValues = getObjectDifferences(defaultValues, formValues);

    const isDirty = Object.keys(changedValues)?.length > 0;
    if (isDirty) {
      const payload = { id, ...changedValues };
      console.log(payload);
      mutate(payload);
    }
  };

  return (
    <StyledDrawer anchor="right" open={!!id} onClose={onClose}>
      <Stack overflow="hidden">
        <HubToolbar
          label="Work Order Details"
          subtitle="Quick view of work order details"
          onClose={onClose}
          direction="left"
        />
        <Box
          sx={{
            height: "100%",
            overflowY: "auto",
            padding: "0 0 25px 0",
            "&::-webkit-scrollbar": { display: "none !important" },
          }}
        >
          <HubHookFormWrapper defaultValues={defaultValues} onSubmit={onSubmit}>
            <Stack padding="25px" gap="25px">
              <QuickWorkOrderDetailsContent {...data} />
              <QuickWorkOrderSubmitButton />
            </Stack>
          </HubHookFormWrapper>
        </Box>
      </Stack>
    </StyledDrawer>
  );
};

export default QuickWorkOrderDetailsDialog;
